import { OEM_FORM_PREVIEW } from "../constants/oemConstants";

const initialState = {
  allSteps: [],
  currentStepNo: 0,
  isPreview: null,
};

const oemReducer = (state = initialState, action) => {
  switch (action.type) {
    case OEM_FORM_PREVIEW:
      return {
        ...state,
        allSteps: [...action.payload.steps],
        currentStepNo: action.payload.currentStep,
        isPreview: action.payload.isPreview,
      };
    default:
      return state;
  }
};

export default oemReducer;
